import gql from 'graphql-tag';
import client from '../../client';
export const REGISTER_PROFILE = gql `
  mutation registerProfile($input: RegisterProfilePayload) {
    registerProfile(input: $input)
      @rest(type: "RegisterProfile", path: "internal/users/profile/register", method: "POST") {
      data {
        email
        federationId
        username
      }
    }
  }
`;
export const registerProfile = (input) => {
    return client.mutate({
        mutation: REGISTER_PROFILE,
        variables: {
            input,
        },
    });
};
export default registerProfile;
